import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map } from 'rxjs/internal/operators/map';

@Injectable({ providedIn: 'root' })
export class APIUpdateSubTask {
    constructor(
        private httpClient: HttpClient
    ) { }

    getTask(visaType, taskId) {
        return this.httpClient.get(`/${visaType}/task/${taskId}`).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response.status === 200) {
                    return response;
                }
            })
        );
    }

    getUploadedDocument(url: string) {
        return this.httpClient.get(url).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response && (response.status === 200 || response.status === 204)) {
                    return response;
                }
            })
        );
    }

    postReviewPetitiondocDraft(visatype,caseType, caseId: number, draft: boolean) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/generate/${draft}/fullpdf`, {}).pipe(
            map((response: ImagilityBaseResponse) => {
                if (response.status === 200) {
                    return response;
                }
            })
        );
    }
    getImmiServiceCenters(isPremium,taskTypeId) {
        return this.httpClient.get(`/taskType/${taskTypeId}/serviceCenter/${isPremium}`).pipe(
          map((response: ImagilityBaseResponse) => response.data)
        );
      }

}